module.exports = __webpack_public_path__ + "img/f94c048.jpg";